module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "slide0.39c8d1bb.jpg" + "?" + Date.now();